import http from "../../http-common";

const getDistributionByQueue = (
  initDate,
  endDate,
  queueName,
  token,
  username,
  company
) => {
  return http.get(
    `/api/v1/teams/stats/attendedByDate?limit=99999&initDate=${initDate}&endDate=${endDate}&queueName=${queueName}&token=${token}&username=${username}&company=${company}`
  );
};

const getActualQueues = (token, username, company) => {
  return http.get(
    `/api/v1/teams/stats/actualQueues?limit=99999&token=${token}&username=${username}&company=${company}`
  );
};

const getDistributionByHours = (
  initDate,
  endDate,
  queueName,
  token,
  username,
  company
) => {
  return http.post(
    `/api/v1/teams/stats/attendedByHours?limit=99999&initDate=${initDate}&endDate=${endDate}&token=${token}&username=${username}&company=${company}`,
    { queues: queueName }
  );
};

const getAttendedByAgent = (
  initDate,
  endDate,
  token,
  username,
  company,
  queueName
) => {
  return http.get(
    `/api/v1/teams/stats/attendedByAgent?limit=99999&initDate=${initDate}&endDate=${endDate}&token=${token}&username=${username}&company=${company}&queue=${queueName}`
  );
};

const getAttendedByAgentOutbound = (
  initDate,
  endDate,
  token,
  username,
  company,
  queueName
) => {
  return http.get(
    `/api/v1/teams/stats/attendedByAgentOutbound?limit=99999&initDate=${initDate}&endDate=${endDate}&token=${token}&username=${username}&company=${company}`
  );
};

const getAttendedByAgentOutboundNum = (
  initDate,
  endDate,
  token,
  username,
  company,
  queueName
) => {
  return http.get(
    `/api/v1/teams/stats/attendedByAgentOutboundNum?limit=99999&initDate=${initDate}&endDate=${endDate}&token=${token}&username=${username}&company=${company}`
  );
};
const StatsService = {
  getDistributionByQueue,
  getActualQueues,
  getDistributionByHours,
  getAttendedByAgent,
  getAttendedByAgentOutbound,
  getAttendedByAgentOutboundNum,
};

export default StatsService;
